<footer class="footer py-3 ">
  <div class="smaller-font">
      <div class="text-body-secondary">
        <p [innerHTML]="'footer.disclaimers' | translate"></p>
      </div>
  </div>
</footer>